import { FormHelperText } from '@mui/material'
const HelperText = ({ errors, uischema }: any) => {
  return (
    <>
      {uischema?.config?.main?.description && (
        <FormHelperText sx={{...uischema?.config?.style?.descriptionStyle}}>{uischema?.config?.main?.description}</FormHelperText>
      )}
      <FormHelperText error={true} sx={{ fontSize: "10px", marginTop: 0, ...uischema?.config?.style?.errorMessageStyle }}>
        {errors !== ""
          ? uischema?.config?.main?.errorMessage
            ? uischema?.config?.main?.errorMessage
            : errors || "\u00A0"
          : "\u00A0"}
      </FormHelperText>
    </>
  )
}

export default HelperText